<template>
  <div
    ref="elementRef"
    class="scroll-reveal reveal"
    :class="{ 'reveal--visible': isVisible }"
  >
    <slot :visible="isVisible" />
  </div>
</template>

<script>
export default {
  name: 'ScrollReveal',
  props: {
    threshold: {
      type: Number,
      default: 0.15
    }
  },
  data() {
    return {
      isVisible: false,
      observer: null
    }
  },
  mounted() {
    if (!this.$refs.elementRef) return

    if (typeof IntersectionObserver === 'undefined') {
      this.isVisible = true
      return
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true
          if (this.observer) {
            this.observer.disconnect()
          }
        }
      },
      {
        threshold: this.threshold,
        rootMargin: '0px 0px -8% 0px'
      }
    )

    this.observer.observe(this.$refs.elementRef)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>
